import { render, staticRenderFns } from "./GeneralCollapseSlots.vue?vue&type=template&id=751b7360&scoped=true"
import script from "./GeneralCollapseSlots.vue?vue&type=script&lang=js"
export * from "./GeneralCollapseSlots.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "751b7360",
  null
  
)

export default component.exports